import Type from "@/model/types/Type";



const type = {
    NONE : 1,
    FINISH_WITH_SUCCESS : 2,
    FINISH_WITH_ERROR : 3,
    REVERSE : 4,
    CHANGE_STEP:5,
    REINSTALL:6,
    SET_OPERATION_STATUS:7,
    DELETE : 90,
}

const list = [
    {
        value: type.NONE,
        text: "Nenhuma",
    },
    {
        value: type.CHANGE_STEP,
        text: "Alterar Etapa",
    },
    {
        value: type.FINISH_WITH_SUCCESS,
        text: "Finalizar com sucesso",
    },
    {
        value: type.FINISH_WITH_ERROR,
        text: "Finalizar com erro",
    },
    {
        value: type.REVERSE,
        text: "Estornar finalização",
    },
    {
        value: type.REINSTALL,
        text: "Atualizar Fluxo",
    },
    {
        value: type.SET_OPERATION_STATUS,
        text: "Alterar Status Operacional",
    },
    {
        value: type.DELETE,
        text: "Excluir",
    },

]

/*Listagem somente se OF estiver pendente sem Fluxo informado*/
const listPendingNotFlow = [
    {
        value: type.NONE,
        text: "Nenhuma",
    },
    {
        value: type.FINISH_WITH_SUCCESS,
        text: "Finalizar com sucesso",
    },
    {
        value: type.FINISH_WITH_ERROR,
        text: "Finalizar com erro",
    },
    {
        value: type.REINSTALL,
        text: "Atualizar Fluxo",
    },
    {
        value: type.SET_OPERATION_STATUS,
        text: "Alterar Status Operacional",
    },
    {
        value: type.DELETE,
        text: "Excluir",
    },

]

/*Listagem somente se OF estiver pendente com Fluxo informado*/
const listPendingWithFlow = [
    {
        value: type.NONE,
        text: "Nenhuma",
    },
    {
        value: type.CHANGE_STEP,
        text: "Alterar Etapa",
    },
    {
        value: type.FINISH_WITH_SUCCESS,
        text: "Finalizar com sucesso",
    },
    {
        value: type.FINISH_WITH_ERROR,
        text: "Finalizar com erro",
    },
    {
        value: type.REINSTALL,
        text: "Atualizar Fluxo",
    },
    {
        value: type.SET_OPERATION_STATUS,
        text: "Alterar Status Operacional",
    },
    {
        value: type.DELETE,
        text: "Excluir",
    },

]



/*Listagem somente se OF estiver finalizada*/
const listFinished = [
    {
        value: type.NONE,
        text: "Nenhuma",
    },
    {
        value: type.REVERSE,
        text: "Estornar finalização",
    },
    {
        value: type.DELETE,
        text: "Excluir",
    },

]

/*Listagem somente para replicar ações sem fluxo informado*/
const listCopyNotFlow = [
    {
        value: type.NONE,
        text: "Limpar todas",
    },
    {
        value: type.FINISH_WITH_SUCCESS,
        text: "Finalizar todos com sucesso",
    },
    {
        value: type.FINISH_WITH_ERROR,
        text: "Finalizar todos com erro",
    },
    {
        value: type.REVERSE,
        text: "Estornar finalização de todas",
    },
    {
        value: type.REINSTALL,
        text: "Atualizar Fluxo de todas",
    },
    {
        value: type.SET_OPERATION_STATUS,
        text: "Alterar Status Operacional de todas",
    },
    {
        value: type.DELETE,
        text: "Excluir todas",
    },

]
/*Listagem somente para replicar ações com fluxo informado*/
const listCopyWithFlow = [
    {
        value: type.NONE,
        text: "Limpar todas",
    },
    {
        value: type.CHANGE_STEP,
        text: "Alterar Etapa",
    },
    {
        value: type.FINISH_WITH_SUCCESS,
        text: "Finalizar todos com sucesso",
    },
    {
        value: type.FINISH_WITH_ERROR,
        text: "Finalizar todos com erro",
    },
    {
        value: type.REVERSE,
        text: "Estornar finalização de todas",
    },
    {
        value: type.REINSTALL,
        text: "Atualizar Fluxo de todas",
    },
    {
        value: type.SET_OPERATION_STATUS,
        text: "Alterar Status Operacional de todas",
    },
    {
        value: type.DELETE,
        text: "Excluir todas",
    },

]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    listPendingNotFlow,
    listPendingWithFlow,
    listFinished,
    listCopyNotFlow,
    listCopyWithFlow,
    contains,
}


